import RBACMatrixRepository from "@/core/administration/repositories/RBACMatrixRepository";
import { ServiceContainer } from "@/core/di";

export class RBACMatrixServiceProvider {
  private static instance: RBACMatrixServiceProvider;
  private rbacRepository: RBACMatrixRepository;

  private constructor() {
    const serviceContainer = ServiceContainer.getInstance();
    this.rbacRepository =
      serviceContainer.getRepository("rbacMatrix");
  }

  public static getInstance(): RBACMatrixServiceProvider {
    if (!RBACMatrixServiceProvider.instance) {
      RBACMatrixServiceProvider.instance = new RBACMatrixServiceProvider();
    }
    return RBACMatrixServiceProvider.instance;
  }

  public getRepository(): RBACMatrixRepository {
    return this.rbacRepository;
  }

  public setRepository(repository: RBACMatrixRepository): void {
    this.rbacRepository = repository;
  }
}

export default RBACMatrixServiceProvider;
